<template>
    <div class="picture-container row">
        <div class="col-lg-6">
            <label>{{ $t('Preview') }}</label>
            <div class="preview">
                <img v-if="imageUrl" :src="imageUrl" class="picture-src">
                <img v-else-if="value" :src="`/api/image/${value}`"
                     class="picture-src">
            </div>
        </div>
        <div class="col-lg-6">
            <label>{{ $t('Upload') }}</label><br>
            <input type="file" accept="image/png, image/jpeg" ref="fileUpload" @change="fileChange" style="display: none;">
            <p-button v-if="disabledComponent" round type="default" @click="$refs.fileUpload.click()" disabled class="btn-one-size-dropdown">{{ $t('New Picture') }}</p-button>
            <p-button v-else round type="default" @click="$refs.fileUpload.click()" class="btn-one-size-dropdown">{{ $t('New Picture') }}</p-button>
            <br>
            <span class="small text-muted">{{`${$t('Max size')}: ${this.fileSizeLimitMb}Mb`}}</span>
            <div>
                <p-button v-if="imageUrl && disabledComponent" round type="default" @click="clear" disabled="true" class="btn-one-size-dropdown">{{ $t('Delete') }}
                </p-button>
                <p-button v-else-if="imageUrl" round type="default" @click="clear" class="btn-one-size-dropdown">{{ $t('Delete') }}
                </p-button>
                <p-button v-else-if="value && disabledComponent" round type="danger" @click="$emit('input', null) " disabled="true" class="btn-one-size-dropdown">
                    {{$t('Delete')}}
                </p-button>
                <p-button v-else-if="value" round type="danger" @click="$emit('input', null) " class="btn-one-size-dropdown">
                    {{$t('Delete')}}
                </p-button>
            </div>
        </div>
    </div>
</template>

<script>
  import { Button, Input } from 'element-ui'

  export default {
    name: 'BasicUpload',
    components: {
      [Input.name]: Input,
      [Button.name]: Button
    },
    props: {
      value: {
        type: String
      },
      imageUrl: {
        type: String,
        default: null
      },
      change: {
        type: Function
      },
      disabledComponent: {
          type: Boolean,
          default: false
      }
    },
    data () {
      return {
        fileSizeLimitMb: 2,
        fileName: null
      }
    },
    methods: {
      async fileChange (e) {
        if (e.target.files.length > 0) {
          try {
            const file = e.target.files[0]
            const getDataURL = (file) => new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.readAsDataURL(file)
              reader.onload = () => resolve(reader.result)
              reader.onerror = error => reject(error)
            })

            if (file.size > (1024 * 1024 * this.fileSizeLimitMb)) {
              this.$notify({ type: 'danger', message: this.$t('File is too big.') })
            } else {
              const imageUrl = await getDataURL(file)
              this.fileName = file.name
              this.change(imageUrl)
            }

          } catch (e) {
            this.$notify({ type: 'danger', title: this.$t('Error'), message: e.message })
          }
        }
      },
      clear () {
        const input = this.$refs.fileUpload
        input.value = ''
        this.fileName = null
        this.change(null)
      }
    }
  }
</script>

<style scoped lang="scss">
    .picture-container .preview {
        max-height: 200px;
        height: 150px;
        border: darkgrey solid 1px;
        background-color: #EEEEEE;
        overflow: hidden;
    }

    .picture-container .preview img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .input-upload {
        display: flex;
        justify-content: center;
        align-items: center;

        .file {
            margin: 0;
            input[type=file] {
                max-width: 100px;
                color: transparent;
            }
        }
    }

    @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
    }
</style>